/*
 * Javascript for sidebar
*/
(function($) {
	if($('.sidebar').length) {
		//Sticky sidebar for news & views
		/*$(window).resize(function(){
			if(Modernizr.mq('(min-width: '+screen_md+'px)')) {
				if($('body.news-and-views').length) {
					var sidebar = $('.sidebar'),
						sidebar_offset = sidebar.offset().top,
						top = $('.breadcrumb').offset().top,
						fixed_top = false;
					function sidebarScroll() {
						if(Modernizr.mq('(min-width: '+screen_md+'px)')) {
							var y = $(window).scrollTop();
							$('.content-container .col-md-3:first').height($('.content-container').height());
							//console.log('('+y+' >= '+top+' ) && ('+sidebar.height()+' < '+$(window).height()+')');
							if ((y >= top) && (!sidebar.hasClass('fixed')) && (sidebar.height() < $(window).height())) {
								if(!fixed_top) {
									 //Trying 60 for a while to see if it works better that calculating the top:
									fixed_top = 60; //sidebar_offset - $(window).scrollTop() - 3;
								}
								$('.sidebar').addClass('fixed').css({
									'width' : $('.content-container .col-md-3').width(),
									'top' : fixed_top
								});
							} else if (y < top) {
								$('.sidebar').removeClass('fixed');
							}
						} else {
							$('.sidebar').removeClass('fixed').width('auto');
						}
					}
					$(document).ready(function () {
						//sidebarScroll();
						$(window).scroll(function (event) {
							sidebarScroll();
						});
						$(window).scroll(function (event) {
							if(sidebar.hasClass('fixed')) {
								$('.sidebar').css({
									'width' : $('.content-container .col-md-3').width()
								});
							}
						});
					});
				}
			} else {
				$('.sidebar').removeClass('fixed');
				$('.content-container .col-md-3:first').height('auto');
			}
		}).resize();*/

		//Facebook Share
		$(document).on('click','.sidebar .fb', function(e) {
			FB.ui({
				method: 'share',
				href: $(this).data('entry-url'),
			}, function(response){});
		});
		$(document).on('click','.sidebar .twitter, .sidebar .messenger', function(e) {
			width = 500;
			height = 400;
			var leftPosition, topPosition;
			//Allow for borders.
			leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
			//Allow for title and status bars.
			topPosition = (window.screen.height / 2) - ((height / 2) + 50);
			var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
			u=location.href;
			t=document.title;
			window.open($(this).attr('href'),'sharer', windowFeatures);
			return false;
		});
	}
})(jQuery);
